import React, { useEffect } from 'react'

import { isProduction } from '@fourthwall/utils'

import { AppsPledgeView } from './AppsPledgeView'
import { usePledge } from './hooks'

export const AppsPledge = () => {
  const { pledge, setCharity, deleteCharity, setCharityPercentage } = usePledge()

  const pledgeUrl = isProduction() ? 'https://www.pledge.to' : 'https://staging.pledge.to'

  useEffect(() => {
    const script = document.createElement('script')
    script.src = `${pledgeUrl}/assets/widget.js`
    document.body.appendChild(script)
  }, [])

  const pledgePublicKey = isProduction()
    ? 'e6254344f5ef2f63182a17450857da81'
    : 'afc9339e6e04b98281e92349fdb5b350'

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Verify the message is from the expected origin for security
      if (event.origin !== pledgeUrl) {
        return
      }

      const data = JSON.parse(event.data)
      if (data.action === 'updateEvent') {
        setCharity({
          charityId: data.data.beneficiary_uuid,
          charityName: data.data.beneficiary_details.name,
          charityLogoUrl: data.data.beneficiary_details.logo,
        })
      }
    }

    window.addEventListener('message', handleMessage)

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  const handlePercentageChange = (percentage: number) => {
    if (pledge.charity && percentage !== pledge.charity.percentage) {
      setCharityPercentage({ percentage })
    }
  }

  return (
    <AppsPledgeView
      publicKey={pledgePublicKey}
      currentCharity={pledge.charity}
      clearCharity={deleteCharity}
      onPercentageChange={handlePercentageChange}
    />
  )
}
